export const studyEditorResponsiveLayoutSx = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: 2,
} as const;

export const studyEditorResponsiveColumnSx = {
  flex: 1,
  minWidth: 0,
} as const;